// The pure validation of a position written in the field (rules V1-V3 of story 177): nothing here touches the
// screen, so the field, the "Move" button and Enter all ask the same question.

/** The four codes the screen translates by themselves (CU9); any other failure gets the generic text. */
export const TRANSLATED_ERROR_CODES = ['SEQUENCE_CHANGED', 'JOB_NOT_IN_SEQUENCE', 'POSITION_OUT_OF_RANGE', 'POSITION_UNCHANGED']

/**
 * Is `text` a position the job can be moved to?
 * V1: a whole number ("3"; not "", "3,5", "3.5", "abc" nor "-2"). V2: between 1 and `max`. V3: not where it is now.
 *
 * @param {String} text What the user wrote
 * @param {Object} options
 * @param {Number} options.current The job's position now
 * @param {Number} options.max The number of jobs of the machine
 * @returns {{ valid: Boolean, value: Number }} `value` is the position when valid, 0 when not
 */
export const validatePosition = (text, { current, max }) => {
  const written = String(text ?? '').trim()
  if (!/^\d+$/.test(written)) return { valid: false, value: 0 }
  const value = Number(written)
  if (!Number.isSafeInteger(value) || value < 1 || value > max || value === current) return { valid: false, value: 0 }
  return { valid: true, value }
}

/**
 * The error code of a failed move or preview, and with it how it is told to the user (CU9, contract §5): a
 * warning with the translated code for the four codes of the contract; for anything else (other codes, 401, 403,
 * a network failure) an error with the generic text. Sun's `message` is never shown.
 *
 * @param {Object} error What the API function threw
 * @returns {{ translated: Boolean, code: String }}
 */
export const classifyMoveError = (error) => {
  const code = error?.data?.code
  return TRANSLATED_ERROR_CODES.includes(code) ? { translated: true, code } : { translated: false, code: '' }
}
